import { getUsersState } from '../../redux/selectors';

export const getCreateUserState = state => getUsersState(state).createUser;
export const getCreateUser = state => getCreateUserState(state).userToCreate;
export const getCreatedUser = state => getCreateUserState(state).createdUser;
